import Vue from 'vue'

Vue.directive('blink_on_create', {
  bind: (el, binding) => {
    if (!binding.value) return
    el.classList.add('blink')
    setTimeout(() => {
      el.classList.remove('blink')
    }, 1500)
  },
})
